import { useEffect, useState } from "react";
import { useAppSettingsStore } from "@/common/stores/persistingStores/app/appSettingsStore";
import { AppSettingsState } from "@/common/stores/persistingStores/app";
import { TimerProps } from "./types";

const Timer = (props: TimerProps) => {
	const { startDate, isEndDate, className } = props;

	const timeDiference = useAppSettingsStore(
		(state: AppSettingsState) => state.timeDiference
	);
	const [timer, setTimer] = useState("");
	const [timerStarted, setTimerStarted] = useState(false);
	let interval: any;

	const secondToTimeString = (totalSecond: number) => {
		let seconds: any = Math.floor(totalSecond % 60);
		let minutes: any = Math.floor((totalSecond / 60) % 60);
		let hours: any = Math.floor(totalSecond / (60 * 60));
		
		if (hours >= 24) {
			let numberOfHours = hours % 24;
			let numberOfDays = Math.floor(hours / 24);

			return numberOfHours
				? `${numberOfDays}d ${numberOfHours}h`
				: `${numberOfDays}d`;
		}

		hours = hours < 10 ? "0" + hours : hours;
		minutes = minutes < 10 ? "0" + minutes : minutes;
		seconds = seconds < 10 ? "0" + seconds : seconds;

		return `${hours}:${minutes}:${seconds}`;
	};

	useEffect(() => {
		if (interval) {
			clearInterval(interval);
		}
		if (timerStarted) {
			setTimerAccordingly();

			interval = setInterval(() => {
				setTimerAccordingly();
			}, 1000);
			return () => {
				if (interval) {
					clearInterval(interval);
				}
			};
		}
		return undefined;

		function setTimerAccordingly() {
			let initialSeconds: number = Math.round(
				(Date.now() + (timeDiference || 0) - Date.parse(startDate ?? "")) / 1000
			);
			initialSeconds = initialSeconds * (isEndDate ? -1 : 1);
			initialSeconds = initialSeconds < 0 ? 0 : initialSeconds;
			setTimer(secondToTimeString(initialSeconds));
		}
	}, [timerStarted, isEndDate, startDate, timeDiference]);

	if (timerStarted === false) {
		setTimerStarted(true);
	}

	return <div className={className}>{timer}</div>;
};

export default Timer;
